import {
    Input,
    Label,
} from "reactstrap";
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const SquareRadioButton = ({ value, valueChangeHandler, initialValue, children, direction, name }) => { 
    const height = 35;
    const width = 35;
    const styles = {
        radioStyle: {
            width: width,
            height: height,
        },
        labelContentTop: {
            marginTop: height + 5
        },
        labelContentBottom: {
            marginBottom: height
        }
    }

    const directionCss = direction === RadioDirection.Bottom ? "bottom" : direction === RadioDirection.Right ? 'right' : direction === RadioDirection.Top ? 'top' : 'left';
    return (
        <div className="custom-radios d-flex">
            <Label className="custom-input-label mb-0 d-flex align-items-end justify-content-center" >
                <div style={direction === RadioDirection.Top ? styles.labelContentTop : styles.labelContentBottom }>
                    {children} 
                </div>
                
                <Input
                    required
                    value={value}
                    type="radio"
                    name={name}
                    className="ml-1 radio-input"
                    onChange={valueChangeHandler}
                    checked={value === initialValue}
                />
                <span className={`custom-radio d-flex justify-content-center align-items-center ${directionCss}`} style={styles.radioStyle}>
                    <FontAwesomeIcon icon={faCheck} size="2x" style={{ color: "var(--base-color-dark-blue)", }} />
                </span>
            </Label>
        </div>
    )
}

export const RadioDirection = {
    Left: 1,
    Right: 2,
    Bottom: 3,
    Top: 4
}